import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCarthrottleComponent } from './simple-icons-carthrottle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCarthrottleComponent ],
    exports:      [ SimpleIconsCarthrottleComponent ],
    bootstrap:    []
})
export class SimpleIconsCarthrottleModule {}
